import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData, StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisIncidentTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { incidentsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.service'
import { StatisticalAnalysisIncidentsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/incidents-dossier/incidents-dossier.model'
import { StatisticalAnalysisIncidentsStatisticsDossierBaseRequest, StatisticalAnalysisIncidentsStatisticsDossierGroupRequest, StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.dto'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import i18n from '@/lang/i18n'
import { Options } from 'highcharts'

export class StatisticalAnalysisHandlerChartIncidentsDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public async getChart(): Promise<Options> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisIncidentsDossierExternalInfo
        const baseRequest: StatisticalAnalysisIncidentsStatisticsDossierBaseRequest = incidentsStatisticsDossierService.getBaseRequest(sidebarFilter)
        const groupRequest: StatisticalAnalysisIncidentsStatisticsDossierGroupRequest = {
            groupBy1: this.statisticalAnalysisFilters?.xAxis.groupBy1 as StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum,
            groupBy2: this.statisticalAnalysisFilters?.xAxis.groupBy2 as StatisticalAnalysisIncidentsStatisticsDossierGroupRequestEnum
        }
        const typeCase = sidebarFilter?.typeSearch?.map((item: StatisticalAnalysisSidebarItemCombo) => item.id) as StatiscalAnalysisTypeCases[]
        const state = sidebarFilter.trackingGeneralSelected?.key as StatisticalAnalysisIncidentTypes
        const response: StatisticalAnalysisViewDetailChartData = await incidentsStatisticsDossierService.getDetailViewChart(typeCase, state, baseRequest, groupRequest)

        return {
            xAxis: {
                categories: response.categories
            },
            yAxis: {
                title: {
                    text: `${i18n.tc('statisticalAnalysis.charts.totalIncidents')}`
                }
            },
            series: response.series
        }
    }
}
